import CryptoJS from 'crypto-js'

// المفتاح السري (16 بايت)
const secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY)
const IV_KEY = CryptoJS.enc.Base64.parse(process.env.REACT_APP_IV_KEY) 

// دالة للتشفير
export const encryptData = (data) => {
  const iv = CryptoJS.lib.WordArray.random(16)

  // تقسيم البيانات إلى نصية وملفات
  const filesData = {}

  const handleData = (keys, parentKey = '') => {
    Object.keys(keys).forEach((key) => {
      const item = keys[key]
      const fullKey = parentKey ? `${parentKey}[${key}]` : key
      if (item instanceof Array) {
        item?.forEach((i, index) => {
          handleData(i, `${fullKey}[${index}]`)
        })
      } else if (item instanceof File || item instanceof Blob) {
        filesData[fullKey] = item
      }
    })
  }
  handleData(data)

  // تشفير البيانات النصية فقط
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),  // تشفير البيانات النصية فقط
    secretKey,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  )

  // دمج النص المشفر مع الملفات غير المشفرة
  const result = {
    iv: iv.toString(CryptoJS.enc.Base64),  // تحويل IV إلى Base64
    value: encrypted.ciphertext.toString(CryptoJS.enc.Base64),  // النص المشفر
    ...filesData  // الملفات غير المشفرة
  }

  // دمج النص المشفر والملفات في JSON واحد
  return result
}

// دالة لفك تشفير البيانات
export const decryptData = (encryptedData) => {
    const { iv, value } = encryptedData
    const ivBytes = CryptoJS.enc.Base64.parse(iv)
    const encryptedBytes = CryptoJS.enc.Base64.parse(value)

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedBytes },
        secretKey,
        {
            iv: ivBytes,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    )

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
}

export const decryptFile = (encryptedData) => {
  const decrypted = CryptoJS.AES.decrypt(
      encryptedData, 
      secretKey, 
      { iv: IV_KEY, mode: CryptoJS.mode.CBC }
  )
  return decrypted.toString(CryptoJS.enc.Base64) // نرجع الملف كـ base64
}